import React, { useState } from "react";
import "./SearchBar.css";

const SearchBar = ({setSearch,Search}) => {
  

  
  const clearInput = () => {
    setSearch("");
   
  };

  return (
    <div className="search-container">
      <input
        type="text"
        className="search-input"
        placeholder="Search ..."
        value={Search}
        onChange={(e)=>setSearch(e.target.value)}
      />
      {Search && (
        <button className="clear-button" onClick={clearInput}>
          ×
        </button>
      )}
      
    </div>
  );
};

export default SearchBar;
